import script from "./ConfigUsersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigUsersSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigUsersSection.vue?vue&type=style&index=0&id=def5aa82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-def5aa82"]])

export default __exports__